import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';

export const EnergyTrend = ({ story, action, isPaused, config, storyData }) => {
    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <div className={styles.circleBackground}></div>
            <p className={`${styles.size3} ${styles.margin1}`} style={{ zIndex: 2 }}>{storyData.data?.trend}</p>
        </StoryWrapper>
    );
};